import StayUpImg1 from "assets/images/stayUp1.png";
import StayUpImg2 from "assets/images/stayUp2.jpeg";
import StayUpImg3 from "assets/images/stayUp3.png";

export const schedules = [
  {
    title: "Sentient Incentives 6M",
    value: 500,
    percent: 50,
  },
  {
    title: "Lending liquidity 3m+",
    value: 500,
    percent: 50,
  },
  {
    title: "Lending liquidity 3m+",
    value: 500,
    percent: 50,
  },
  {
    title: "Angles 3M+",
    value: 500,
    percent: 50,
  },
  {
    title: "Lemonade defi – no lock",
    value: 500,
    percent: 50,
  },
  {
    title: "Marketing/CEX + MM 3m+",
    value: 500,
    percent: 100,
  },
  {
    title: "Contingency 12m+",
    value: 1300,
    percent: 100,
  },
  {
    title: "Treasury 6M",
    value: 1300,
    percent: 100,
  },
  {
    title: "Team 12 M",
    value: 500,
    percent: 100,
  },
];

export const stayUpData = [
  {
    image: StayUpImg1,
    date: "Jul 28 - 3 min read",
    title:
      "Precog.finance helps you to automatically trade arbitrage in a way that’s never been done before!",
    decs: `The Precog.finance team is hugely excited and proud to introduce Precog.finance into the DeFi arena. We know we will make waves, and are ready to take the world by storm with our world class team. We are currently in the research and development phase.`,
    messages: 324,
    viewed: "12,315",
    link:
      "https://medium.com/@precog.finance/introducing-precog-finance-2f9c0b569e11",
  },
  {
    image: StayUpImg2,
    date: "Jul 28 - 3 min read",
    title:
      "Increasing supply of crypto-derivatives welcomed by institutional investors",
    decs: `In recent years, crypto derivatives have become increasingly popular. Among the first established exchanges to launch options on Bitcoin futures is the Chicago Mercantile Exchange (CME). The CME now offers a crypto derivative that institutional crypto investors are already familiar with from traditional financial institutions. With the increased accessibility of these crypto-derivatives, institutional investors are beginning to take interest in the blockchain asset class.
    `,
    messages: 71,
    viewed: "1,001",
    link:
      "https://medium.com/@precog.finance/increasing-supply-of-crypto-derivatives-welcomed-by-institutional-investors-cc591ffd6bc2",
  },
  {
    image: StayUpImg3,
    date: "Jul 28 - 3 min read",
    title:
      "Crypto Derivatives Are Surging, but What’s Missing from the Market?",
    decs: `After nearly two months of sideways price movement, Bitcoin’s recent breakout has created an ideal environment for another bull market to emerge. Comparing DeFi’s growth with that of 2017, and the crypto mania of that year is a fair comparison. However, this time is different.`,
    messages: 152,
    viewed: "201",
    link:
      "https://medium.com/@precog.finance/increasing-supply-of-crypto-derivatives-welcomed-by-institutional-investors-cc591ffd6bc2",
  },
];

export const dataProgress = [
  {
    type: "Contingency 12m+",
    value: 1300,
  },
  {
    type: "Treasury 6M",
    value: 1300,
  },
  {
    type: "Team 12 m",
    value: 500,
  },
  {
    type: "Marketing/CEX + MM 3m+",
    value: 500,
  },
  {
    type: "Lemonade defi – no lock",
    value: 500,
  },
  {
    type: "Angles 3M+",
    value: 500,
  },
  {
    type: "Uniswap liq 6m+",
    value: 500,
  },
  {
    type: "Lending liquidity 3m+",
    value: 500,
  },
  {
    type: "Sentient Incentives 6M",
    value: 500,
  },
];

export const colors = [
  "#CAB2D6",
  "#FFECA9",
  "#FDBF6F",
  "#3FBAFF",
  "#F06969",
  "#5BD2DA",
  "#A6CEE3",
  "#40374C",
  "#B2DF8A",
];
